'use strict';

(function () {
  'use strict';

  angular.module('msSleep').controller('SleepDiaryCtrl', SleepDiaryCtrl);

  SleepDiaryCtrl.$inject = ['$log', '$q', '$state', 'user', 'userSvc', 'NotifyingSvc'];

  function SleepDiaryCtrl($log, $q, $state, user, userSvc, NotifyingSvc) {
    var vm = this;

    var SLEEP_DIARY_ON_SETTING = 'sleep_diary_enabled:true';
    var SLEEP_DIARY_OFF_SETTING = 'sleep_diary_enabled:false';
    var EMAIL_REMINDER_SETTING = 'sleep_diary_reminder:email';
    var SLEEP_FOCUS = 'condition:insomnia';

    vm.diaryEnabled = false;
    vm.notificationsEnabled = false;

    vm.$onInit = _activate;

    vm.goToSleepActivities = function () {
      NotifyingSvc.notifyEvent(NotifyingSvc.EVENTS.FOCUS_UPDATED, {
        focus: SLEEP_FOCUS
      });
    };

    vm.enableSleepDiary = function () {
      //opt-in to emails by default
      vm.updateSleepSettings(true, true);
    };

    vm.updateSleepSettings = function (enableDiary, enableNotifications) {
      var saveTags = [];
      var removeTags = [];
      $log.debug('perms: ' + enableDiary + ',' + enableNotifications);

      if (enableDiary) {
        saveTags.push(SLEEP_DIARY_ON_SETTING);
        removeTags.push(SLEEP_DIARY_OFF_SETTING);
      } else {
        saveTags.push(SLEEP_DIARY_OFF_SETTING);
        removeTags.push(SLEEP_DIARY_ON_SETTING);
        //can't get emails if you don't have diary
        enableNotifications = false;
      }

      if (enableNotifications) {
        saveTags.push(EMAIL_REMINDER_SETTING);
      } else {
        removeTags.push(EMAIL_REMINDER_SETTING);
      }

      userSvc.saveTagPreferences(saveTags, removeTags).then(function () {
        vm.diaryEnabled = enableDiary;
        vm.notificationsEnabled = enableNotifications;
      });
    };

    ///////////////////////////////

    function _activate() {
      $log.debug('SleepDiaryCtrl activate. User:');
      $log.debug(user);

      if (hasUserPreference(SLEEP_DIARY_ON_SETTING)) {
        vm.diaryEnabled = true;
      }

      if (hasUserPreference(EMAIL_REMINDER_SETTING)) {
        vm.notificationsEnabled = true;
      }
    }

    function hasUserPreference(setting) {
      return user.userPreferences && user.userPreferences[setting] && user.userPreferences[setting].toString() === 'true';
    }
  }
})();